import { InputMask } from "primereact/inputmask";
import { cn } from "../../lib/utils";
import { CircleAlert } from "lucide-react";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const config = {
  '*' : {
    mask:"99 99 99 99 99",
    slotChar:"__ __ __ __ __"
  },
  '+34' : {
    mask:"999 999 999",
    slotChar:"___ ___ ___"
  },
  '+212' : {
    mask: '999 999999',
    slotChar: '___ ______',
  },
  '+596' : {
    mask: '999 9999 99',
    slotChar: '___ ____ __',
  },
  '+590' : {
    mask: '999 9999 99',
    slotChar: '___ ____ __',
  },
}

export default  function OAPhoneInput({
    placeholder = "",
    name,
    error=null,
    className,
    phoneValue,
    onPhoneChange,
    defaultInternationnalCode = '+33',
  }) {
    const {t} = useTranslation()
    const [value,setValue] = useState({
      code: defaultInternationnalCode,
      phone:""
    })
  
    const setChange = (e)=>{
      const {name,value} = e.target
      setValue((prev)=>({...prev,[name]:value}));
    }
  
    useEffect(() => {
      if(onPhoneChange && value.phone)
        onPhoneChange({
          target:{
            name,
            value:`${value.code}${value[name].split(" ").join("")}`
          }
        })
    }, [value])
    
    const used = config[value.code] || config['*'];

    return (
      <fieldset className="flex-1 animate-fade-in-down flex flex-col gap-1">
        <div className="flex justify-center">
          <select 
              name="code" 
              value={value.code}
              onChange={setChange} 
              className={`h-10 w-20 pl-1 text-xl bg-white border-oaBackgroundText border border-r-0 rounded-l-[8px] ${error ? 'border-2 border-r-0 border-oaRed':''}`} 
          >
            <option value="+33">🇫🇷</option>
            <option value="+34">🇪🇸</option>
            <option value="+262">🇫🇷 +262</option>
            <option value="+596">🇫🇷 +596</option>
            <option value="+590">🇫🇷 +590</option>
            <option value="+212">🇲🇦</option> 
          </select>
          <InputMask  
            className={cn(`h-10 w-[calc(100%-40px)] px-2 py-3 border p-inputmask:text-oaBackgroundText bg-white border-oaInputBorderColor tracking-widest rounded-r-[8px] transition-all duration-300 ${error ? 'border-2 border-l-0  border-oaRed':''}`, className)}
            // onChange={onChange}
            mask={used.mask}
            slotChar={used.slotChar}
            name={name}
            type={"tel"}
            placeholder={`${placeholder}`}
            onChange={setChange}
          />
        </div>
       <div className="flex gap-1 justify-start items-start text-oaRed">
          {(error) && <>
            <CircleAlert className="size-4 "/>
            <p className="text-xs flex-1">{t(error)}</p>
          </>}
        </div>
      </fieldset>
    );
  }